import React from 'react';
import successLogo from "../../../assets/icons/eventSuccessfull.svg";
import MyButton from "../../../components/MyButton";

const NewTaskSuccess = ({closeModal}) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100">
      <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center">
        <img src={successLogo} />
        <h1 className="assign-successful-h mb-5 mt-2">Task successfully created</h1>
      </div>
      <div className="d-flex justify-content-center w-100">
        <div className="task-success-btn">
          <MyButton
            type={"primary"}
            content={"Close"}
            onClick={closeModal}
          />
        </div>
      </div>
    </div>
  )
}

export default NewTaskSuccess